export const COMPANY_SUMMARY_SPREADSHEET_FIRM_TOTAL = 'COMPANY_SUMMARY_SPREADSHEET_FIRM_TOTAL';
export const COMPANY_SUMMARY_SPREADSHEET_FUND_TITLE = 'COMPANY_SUMMARY_SPREADSHEET_FUND_TITLE';
export const COMPANY_SUMMARY_SPREADSHEET_FUND_TOTAL = 'COMPANY_SUMMARY_SPREADSHEET_FUND_TOTAL';
export const COMPANY_SUMMARY_SPREADSHEET_HEADER_TITLE = 'COMPANY_SUMMARY_SPREADSHEET_HEADER_TITLE';
